import { APP_BASE_URL } from "../appconfig/Settings";
import axiosInstance from "../config/axiosInstance";

//common api call start

// get All Simple Details
export const getAllDetails = async (slug: any) => {
  try {
    const response = await axiosInstance(APP_BASE_URL + slug);
    return response?.data.data;
  } catch (error) {
    throw error;
  }
};

// get All Simple Details
export const getDetails = async (slug: any) => {
  try {
    const response = await axiosInstance(APP_BASE_URL + slug);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//get Details from id
export const getDetailsFromId = async (
  slug: any,
  parameterName: any,
  id: any
) => {
  try {
    const response = await axiosInstance(
      APP_BASE_URL + slug + `${"?" + parameterName}=` + id
    );
    return response?.data.data;
  } catch (error) {
    throw error;
  }
};

//getSpecificItemDeyails
export const getSpecificItemDetails = async (
  slug: any,
  firstParameterName: any,
  firstValue: any
) => {
  try {
    const response = await axiosInstance(
      APP_BASE_URL + slug + `${"?" + firstParameterName}=` + firstValue
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//getSpecificItemDeyails
export const getFilteredDetails = async (
  slug: any,
  firstParameterName: any,
  firstValue: any,
  secParameterName: any,
  secValue: any,
  thirdParameterName: any,
  thirdValue: any,
  fourthParameterName: any,
  fourthValue: any
) => {
  try {
    const response = await axiosInstance(
      APP_BASE_URL +
        slug +
        `${"?" + firstParameterName}=` +
        firstValue +
        `${"&" + secParameterName}=` +
        secValue +
        `${"&" + thirdParameterName}=` +
        thirdValue +
        `${"&" + fourthParameterName}=` +
        fourthValue
    );
    return response?.data.data;
  } catch (error) {
    throw error;
  }
};

//getSpecificItemDeyails
export const getTwoFilteredDetails = async (
  slug: any,
  firstParameterName: any,
  firstValue: any,
  secParameterName: any,
  secValue: any
) => {
  try {
    const response = await axiosInstance(
      APP_BASE_URL +
        slug +
        `${"?" + firstParameterName}=` +
        firstValue +
        `${"&" + secParameterName}=` +
        secValue
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//Merge PDF Specific Buffer Response
export const getPdfMergeResponse = async (
  slug: any,
  firstParameterName: any,
  firstValue: any,
  secParameterName: any,
  secValue: any,
  thirdParameterName: any,
  thirdValue: any
) => {
  try {
    const response = await axiosInstance(
      APP_BASE_URL +
        slug +
        `${"?" + firstParameterName}=` +
        firstValue +
        `${"&" + secParameterName}=` +
        secValue +
        `${"&" + thirdParameterName}=` +
        thirdValue,
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// getdetaild by id year and quarter id
export const getThreeDetailsByIdParam = async (
  slug: any,
  firstParameterName: any,
  firstValue: any,
  secParameterName: any,
  secValue: any,
  thirdParameterName: any,
  thirdValue: any
) => {
  try {
    const response = await axiosInstance(
      APP_BASE_URL +
        slug +
        `${"?" + firstParameterName}=` +
        firstValue +
        `${"&" + secParameterName}=` +
        secValue +
        `${"&" + thirdParameterName}=` +
        thirdValue
    );
    return response?.data.data;
  } catch (error) {
    throw error;
  }
};

export const getThreeDetailsParam = async (
  slug: any,
  firstParameterName: any,
  firstValue: any,
  secParameterName: any,
  secValue: any,
  thirdParameterName: any,
  thirdValue: any
) => {
  try {
    const response = await axiosInstance(
      APP_BASE_URL +
        slug +
        `${"?" + firstParameterName}=` +
        firstValue +
        `${"&" + secParameterName}=` +
        secValue +
        `${"&" + thirdParameterName}=` +
        thirdValue
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//getSpecificItemDeyails
export const getTwoDetails = async (
  slug: any,
  firstParameterName: any,
  firstValue: any,
  secParameterName: any,
  secValue: any
) => {
  try {
    const response = await axiosInstance(
      APP_BASE_URL + slug + `${"/"}` + firstValue + `${"/"}` + secValue
    );
    return response?.data.data;
  } catch (error) {
    throw error;
  }
};

//getSpecificItemDeyails
export const getTwoDetailsById = async (
  slug: any,
  firstParameterName: any,
  firstValue: any,
  secParameterName: any,
  secValue: any
) => {
  try {
    const response = await axiosInstance(
      APP_BASE_URL +
        slug +
        `${"/" + firstParameterName}` +
        firstValue +
        `${"?" + secParameterName}=` +
        secValue
    );
    return response?.data.data;
  } catch (error) {
    throw error;
  }
};

// getdetaild by id year and quarter id
export const getThreeDetailsById = async (
  slug: any,
  firstParameterName: any,
  firstValue: any,
  secParameterName: any,
  secValue: any,
  thirdParameterName: any,
  thirdValue: any
) => {
  try {
    const response = await axiosInstance(
      APP_BASE_URL +
        slug +
        `${"/" + firstParameterName}` +
        firstValue +
        `${"?" + secParameterName}=` +
        secValue +
        `${"&" + thirdParameterName}=` +
        thirdValue
    );
    return response?.data.data;
  } catch (error) {
    throw error;
  }
};

//getSpecific Details from id
export const getSpecificDetails = async (slug: any, id: any) => {
  try {
    const response = await axiosInstance(APP_BASE_URL + slug + "/" + id);
    return response?.data.data;
  } catch (error) {
    throw error;
  }
};

//common post api
export const postAllData = async (slug: any, requestData: any) => {
  try {
    const response = await axiosInstance.post(APP_BASE_URL + slug, requestData);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const postSingleData = async (requestData: any) => {
  try {
    const response = await axiosInstance.post(APP_BASE_URL + requestData);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//common post api
export const postDataByID = async (slug: any, id: any) => {
  try {
    const response = await axiosInstance.post(APP_BASE_URL + slug + "/" + id);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//updateData
export const updateData = async (slug: any, id: any, requestData: any) => {
  try {
    const response = await axiosInstance.post(
      APP_BASE_URL + slug + "/" + id,
      requestData
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const editData = async (slug: any, requestData: any) => {
  try {
    const response = await axiosInstance.post(APP_BASE_URL + slug, requestData);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//delete data
export const deleteData = async (slug: any, id: any) => {
  try {
    const response = await axiosInstance.delete(APP_BASE_URL + slug + "/" + id);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//common api call end
